<!-- Tooltip.vue -->
<template>
    <div v-if="show" class="absolute z-10 px-2 py-1 text-xs text-white bg-gray-800 rounded">
      {{ content }}
    </div>
  </template>
  
  <script>
  export default {
    props: {
      content: {
        type: String,
        required: true
      },
      show: {
        type: Boolean,
        required: true
      }
    }
  };
  </script>
  